export const roleList = ['Super', 'Admin', 'Owner', 'User'];
export const capabilityList = ['Owner', 'Admin', 'Player'];

export const productImageBasePath = 'https://woofles-images.s3.ap-southeast-2.amazonaws.com/products';
export const displayImageBasePath = 'https://woofles-images.s3.ap-southeast-2.amazonaws.com/shop-displays';
export const productImagePlaceholder = 'comingsoon.jpg';

export const wooflesCartSessionName = 'wooflesCart';